import './style/index.less';
import AccountBanner from './AccountBanner';

export default AccountBanner;
